import { BKJTableWrapper } from 'components/BKJTable/BKJTable.styled';
import { BKJTableRowInfoWrapper } from 'components/BKJTable/BKJTableRow/BKJTableRow.styled';
import { Flex } from 'components/Flex';
import styled, { css } from 'styled-components';

export const EmptyMemberView = styled(Flex)`
  justify-content: center;
  align-items: flex-end;
  width: 100%;
  height: 100%;
`;

export const SearchTeamMembersTitle = styled.div`
  display: flex;
  font-size: 14px;
  line-height: 21px;
  margin-bottom: 4px;
`;

export const H3 = styled.div`
  ${({ theme }) => theme.fonts.PoppinsTextBold};
  font-size: 28px;
  line-height: 34px;
  margin-bottom: 0;
  color: ${({ theme }) => theme.colors.TextDarkGrey};
`;

export const H4 = styled.div`
  ${({ theme }) => theme.fonts.PoppinsText};
  font-weight: 600;
  font-size: 20px;
  line-height: 28px;
  color: ${({ theme }) => theme.colors.TextDarkGrey};
`;

export const PositionName = styled.div`
  font-size: 20px;
  font-weight: 600;
  line-height: 28px;
  color: ${({ theme }) => theme.colors.TextDarkGrey};
`;

export const TextLabel = styled.div`
  font-size: 14px;
  font-weight: 500;
  line-height: 21px;
  color: ${({ theme }) => theme.colors.TextDarkGrey};
`;

export const Text = styled.div<{ noWrap?: boolean }>`
  font-size: 16px;
  font-weight: 500;
  line-height: 21px;
  ${({ noWrap }) =>
    noWrap &&
    css`
      white-space: nowrap;
    `};
  color: ${({ theme }) => theme.colors.TextDarkGrey};
`;

export const BoldText = styled.div`
  font-size: 16px;
  font-weight: 600;
  line-height: 21px;
  color: ${({ theme }) => theme.colors.TextDarkGrey};
`;

export const FormWrapper = styled.form`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
`;

export const RemovePositionDetailsHeaderWrapper = styled.div<{ noBorder?: boolean }>`
  padding: 40px 32px 32px;
  display: flex;
  flex-direction: column;
  justify-content: 'flex-start';
  align-items: 'flex-start';
  gap: 20px;
  width: 100%;
  border-bottom: ${({ noBorder, theme }) =>
    noBorder ? 'none' : `1px solid ${theme.colors.Grey4}`};
  border-top: 1px solid ${({ theme }) => theme.colors.Grey4};
`;

export const RemovePositionDetailsLocationWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: 'flex-start';
  align-items: 'flex-start';
  gap: 16px;
`;

export const RemovePositionDetailsWrapper = styled.div`
  padding: 24px 32px;
  display: flex;
  flex-direction: column;
  justify-content: 'flex-start';
  align-items: 'flex-start';
  width: 100%;
  gap: 20px;
`;

export const RemovePositionDetailsContent = styled.div`
  line-height: 24px;
  color: ${({ theme }) => theme.colors.TextDarkGrey};
`;

export const RemovePositionText = styled.div`
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  color: ${({ theme }) => theme.colors.TextDarkGrey};
`;

export const JanesTableSubheader = styled.div`
  padding: 24px 16px;
  border-bottom: 4px solid ${({ theme }) => theme.colors.Grey4};
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  color: ${({ theme }) => theme.colors.TextDarkGrey};
`;

export const ShiftsTableSubheader = styled.div`
  padding: 24px 32px;
  border-bottom: 4px solid ${({ theme }) => theme.colors.Grey4};
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  color: ${({ theme }) => theme.colors.TextDarkGrey};
`;

export const JanesTableRowInfoWrapper = styled(BKJTableRowInfoWrapper)<{ isGrey?: boolean }>`
  background-color: ${({ isGrey, theme }) => (isGrey ? theme.colors.Grey1 : 'white')};
  cursor: pointer;
`;

export const ShiftsTableRowInfoWrapper = styled(Flex)`
  background-color: #f6f7fb;
`;

export const JanesTableWrapper = styled(BKJTableWrapper)`
  width: 100%;
`;

export const JanesTableData = styled.div`
  padding-left: 25px;
  overflow: hidden;
  display: flex;
  padding: 16px 24px;
  min-width: max-content;
  width: 100%;
  height: 72px;
  background-color: inherit;
  border-bottom: 1px solid ${({ theme }) => theme.colors.Grey3};
`;
